<template>
  <div>
    <card 
      :title="$t('pages.payment_details.labels.location_info')"
      v-if="location !== undefined">
      <el-row class="mb-4">
        <el-col :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.payment_details.labels.id") }}
            <p>{{ location.locationId }}</p>
          </label>
        </el-col>
        <el-col v-if="location.name" :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.payment_details.labels.name") }}
            <p>{{ location.name }}</p>
          </label>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.payment_details.labels.address") }}
            <p>{{ location.address }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.payment_details.labels.city") }}
            <p>{{ location.city }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.payment_details.labels.country") }}
            <p>{{ location.country }}</p>
          </label>
        </el-col>
      </el-row>
    </card>
    <card v-if="!location" class="centered-content">
      <div>
        <p>{{ $t("pages.payment_details.no_location") }}</p>
      </div>
    </card>
    <card 
      v-if="!noTransaction"
      v-loading="loading"
    >
      <form
        class="paymentSPG"
        :spg-context="this.formContext"
        :spg-config="JSON.stringify(this.formConfig)"
        :spg-style="JSON.stringify(this.formStyle)"
      ></form>
    </card>
    <card v-if="noTransaction" 
      :title="$t('pages.payment_details.no_transaction')" >
    </card>
    <div style="text-align: center;">
      <el-button class="button" @click="goBack()" :round="true">
        {{ $t("pages.payment_details.go_back").toUpperCase()  }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("session");

export default {
  data() {
    return {
      transaction: undefined,
      formContext: undefined,
      formConfig: undefined,
      formStyle: undefined,
      noTransaction: false,
      loading : undefined,
      location: this.getLocation()
    };
  },
  methods: {
    ...mapGetters(["getTransaction", "getLocation"]),
    goBack() {
      const params = {
        countryCode: this.location.countryCode,
        partyId: this.location.partyId,
        locationId: this.location.locationId,
        reload: false
      }
      this.$router.replace({
        name: "PaymentMethod",
        params
      });
    }
  },
  mounted() {

    if (this.getTransaction()) {
      this.transaction = this.getTransaction().data;

      const url = this.$router.resolve({
        name: "PaymentCheckout"
      });
      const absoluteURL = new URL(url.href, process.env.VUE_APP_BASE_URL).href;

      this.formContext = this.transaction.brokerTransactionInfo.formContext;
      this.formConfig = {
        amount: this.transaction.amount,
        language: "en",
        paymentMethodList: ["CARD"],
        redirectUrl: absoluteURL
      };
      this.formStyle = {
        layout: 'default',
        theme: 'default',
        color: {
          primary: "#0F6A88",
          secondary: "#026A89",
          border: "#EEF9FA",
          surface: "#EEF9FA",
          header: {
            text: "#0A2240",
            background: ""
            },
          body: {
            text: "#0A2240",
            background: "#EEF9FA"
            }
        },
        font: ""
      };
      let formScript = document.createElement("script");
      formScript.setAttribute(
        "src",
        `${process.env.VUE_APP_SIBS_URL}/assets/js/widget.js?id=${this.transaction.id}`
      );
      document.head.appendChild(formScript);
    } else this.noTransaction = true;
  }
};
</script>
